import { useEffect } from 'react';

import { getSelectedCallId } from '../utils/appStorage';
import { getMyCalls } from '../api';
import { MyPhoneCall } from '../types';

/**
 * Hook to restore selected call from localStorage on mount
 * @param selectedHistoricalCall - Current selected historical call
 * @param setSelectedHistoricalCall - Function to set selected historical call
 */
export const useRestoreSelectedCall = (
  selectedHistoricalCall: MyPhoneCall | undefined,
  setSelectedHistoricalCall: (call: MyPhoneCall | undefined) => void,
) => {
  useEffect(() => {
    const restoreCall = async() => {
      // Only restore if no call is already selected
      if (!selectedHistoricalCall) {
        const savedCallId = getSelectedCallId();
        if (savedCallId) {
          try {
            // Fetch recent calls and find the saved one
            const response = await getMyCalls({ page: 1, page_size: 50 });
            const savedCall = response.results.find((call) => call.id === savedCallId);
            if (savedCall) {
              setSelectedHistoricalCall(savedCall);
            } else {
              // Clear invalid saved call ID
              setSelectedHistoricalCall(undefined);
            }
          } catch (error) {
            console.error('Failed to restore selected call:', error);
            setSelectedHistoricalCall(undefined);
          }
        }
      }
    };

    restoreCall();
  }, [selectedHistoricalCall, setSelectedHistoricalCall]);
};
